// Empty component needed in order for ReactComponent.cs to be generated.
// This component exists in order to generate ReactComponent.cs, and to be able to reference this class in types.
// The ReactComponent C# class is used in order to have a type that matches any React component view model.
// It is used in ContentArea to describe 'componentData'.
// 'ReactComponent' is used as the base class in all generated .cs-files (configured in CSharpWebpackPlugin options in webpack.config.js)

const ReactComponent = {};

export default ReactComponent;
